import { CombinedGraphQLErrors } from '@apollo/client/errors';

/** Mirrors MyStelliumServices.Errors.ErrorCodes.NotificationDeliveryFailed */
export const NOTIFICATION_DELIVERY_FAILED_CODE = 'NOTIFICATION_DELIVERY_FAILED';

/** Mirrors MyStelliumServices.Errors.ErrorCodes.AccountEmailAlreadyUsed */
export const ACCOUNT_EMAIL_ALREADY_USED_CODE = 'ACCOUNT_EMAIL_ALREADY_USED';

export function isNotificationDeliveryError(error: unknown): boolean {
  return hasGraphQlErrorCode(error, NOTIFICATION_DELIVERY_FAILED_CODE);
}

export function isAccountEmailAlreadyUsedError(error: unknown): boolean {
  return hasGraphQlErrorCode(error, ACCOUNT_EMAIL_ALREADY_USED_CODE);
}

/** Message for ACCOUNT_EMAIL_ALREADY_USED, for the current investisseur or the given names */
export function accountEmailAlreadyUsedMessage(names?: string[]): string {
  return names?.length
    ? `Un compte MyStellium existe déjà avec l'adresse email de : ${names.join(', ')}`
    : "Un compte MyStellium existe déjà avec l'adresse email de cet investisseur.";
}

export function hasGraphQlErrorCode(error: unknown, code: string): boolean {
  return CombinedGraphQLErrors.is(error) && error.errors.some(graphQlError => graphQlError.extensions?.['code'] === code);
}
